<div class="m-3" *ngIf="maplerace">
    <div id="accordion">
        <div *ngFor='let city of maplerace.citys' class="card mb-1"  data-toggle="collapse" attr.data-target="#a{{city._id}}" aria-expanded="false" attr.aria-controls="{{city.name}}">
            <button *ngIf="city.nbRaceFinished == city.races.length" class="btn btn-success mb-3" type="button"  id="headingOne">
                    <h5>{{ city.name }}</h5>
                    <mat-icon *ngIf="city.nbRaceFinished == city.races.length">check_circle</mat-icon>
            </button>
            <button *ngIf="city.nbRaceFinished < city.races.length || city.started" class="btn btn-warning mb-3" type="button"  id="headingOne">
                    <h5>{{ city.name }}</h5>
                    <mat-icon>directions_run</mat-icon>
            </button>
            <button *ngIf="!city.nbRaceFinished && !city.started" class="btn btn-link mb-3" type="button"  id="headingOne">
                    <h5>{{ city.name }}</h5>
                    <mat-icon >location_city</mat-icon>
            </button>
            
            <span id="a{{ city._id }}"   [ngClass]="{'collapse' : true, 'show' : city.nbRaceFinished < city.races.length || city.started }" attr.aria-labelledby="headingOne" data-parent="#accordion"> 
                <span *ngFor='let race of city.races' class="card m-3" style="width: 18rem; display: inline-block;">
                    <img class="card-img-top" src="assets/images/{{race.code}}-min.jpeg" alt="Card image cap">
                    <div class="card-body">
                    <h5 class="card-title">{{ race.name }}</h5>
                    <p><ngb-progressbar  type="danger" [value]="race.progress">{{ (race.progress && race.progress != "NaN") ? race.progress + '%' : '' }}</ngb-progressbar></p>
                    </div>
                </span>
            </span>

            
        </div> 
    </div>

</div>